import React from "react";
import getPageMargins from "./getPageMargins";

export const VisitRoshetaPrint = React.forwardRef(({ rosheta }, ref) => {
  return (
    <div
      className="bg-white text-dark text-bold"
      style={{ fontFamily: "Centaur" }}
      ref={ref}
    >
      <div>
        <style>{getPageMargins()}</style>

        <div
          style={{
            minHeight: "100vh",
            width: "100%",
            // background: "#FAFAF9",
            display: "flex",
            justifyContent: "center",
            padding: "10vh 24px",
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            color: "#111111",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{ width: "100%", paddingLeft: "10%", paddingRight: "10%" }}
          >
            {/* Rows */}
            <div>
              {rosheta.map((r, index) => {
                const isLast = index === rosheta.length - 1;
                return (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "22px 0",
                      borderBottom: isLast ? "none" : "1px solid #DEDEDE",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "clamp(1.05rem, 2vw, 1.3rem)",
                        fontWeight: 500,
                        letterSpacing: "-0.01em",
                      }}
                    >
                      {r.tradeLabel}
                    </span>

                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        fontFamily:
                          "'SF Mono', 'Fira Code', ui-monospace, monospace",
                        fontSize: "clamp(0.95rem, 1.8vw, 1.1rem)",
                        color: "#111111",
                      }}
                    >
                      {r.direction}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* Footer count */}
            <div
              style={{
                paddingTop: 20,
                fontSize: 12,
                color: "#6B6B6B",
                textAlign: "right",
              }}
            >
              {rosheta.length} {rosheta.length === 1 ? "position" : "positions"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
export default VisitRoshetaPrint;
